var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`button-component ${_vm.mini ? 'mini' : ''} ${_vm.disabled ? 'disabled' : ''}`,style:(_vm.buttonStyle)},[(_vm.icon)?_c('Icon',{style:(`color: ${_vm.color}; ${_vm.label ? '' : 'margin: 0;'}`),attrs:{"name":_vm.icon,"size":_vm.iconSize || '12px'}}):_vm._e(),_c('span',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }